<template>
  <model-table
    ref="modelTable"
    :collection="unknownPayments"
    :columns="[
      { field: 'id' },
      { field: 'state' },
      { field: 'handledType' },
      { field: 'stripePaymentIntentId' },
      { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
      { field: 'notes', component: 'scroll-area', style: 'width: 600px; height: 100px;' }
    ]"
    :sort-by="sortBy"
    :descending="descending"

    :show-add="false"
    :show-edit="false"

    :edit-on-row-click="false"
    @row-clicked="row => handleRowClick(row)"
  >
    <unknown-payment-form />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import UnknownPaymentForm from 'src/modules/admin/developer/UnknownPaymentForm'

export default {
  name: 'UnknownPaymentTable',
  components: {
    ModelTable,
    UnknownPaymentForm
  },
  props: {
    sortBy: {
      type: String,
      required: false,
      default: 'id'
    },
    descending: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    handleRowClick (unknownPayment) {
      this.$refs.modelTable.edit(unknownPayment)
    }
  },
  models: {
    unknownPayments: 'default'
  }
}
</script>
